import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const searchAPI = collectionEngineV1('/search');
export const all = (q, c) => searchAPI('GET', `/?${toQuery({
    q: q,
    creditorId: c?.creditorId,
    entity: c?.entity,
})}`);
//# sourceMappingURL=search.js.map